import angular from 'angular';
import akamSegmentedButton from './segmented-button-component';
import i18n from '../i18n';

export default angular
  /**
   * @ngdoc module
   * @name akamai.components.segmented-button
   *
   * @guideline https://design.akamai.com/components/segmented-button/
   *
   * @description
   * A segmented button component is similar to a combo box. It allows user to chose one of
   * multiple options.
   *
   * The difference is that a segmented button component presents all allowed options to the user
   * and each one can be selected by clicking its button.
   *
   * @example segmented-button.html
   * <akam-segmented-button ng-model="..." options="..."></akam-segmented-button>
   */
  .module('akamai.components.segmented-button', [
    i18n.name
  ])

  /**
   * @ngdoc directive
   * @name akamSegmentedButton
   * @module akamai.components.segmented-button
   *
   * @description Creates a segmented button component.
   *
   * @param {string | boolean} ngModel The segmented button's state.
   *
   * @param {Object[]} options Array of options describing each button in the component.
   * @param {string | TranslateKey} options[].title Label shown on a button.
   * @param {string | boolean} options[].value Value which should be set on ngModel when button
   * is clicked.
   * @param {string} [options[].class=seg-button-default] Class added to a button when its values is set
   * in ngModel.
   * @param {string} [options[].disabled=false] Whether button should be disabled.
   *
   * @param {string} [size=md] Size of the button (xs, sm, md (default), lg).
   *
   * @param {Function} [ngChange=null] Function called when ngModel is changed.
   */
  .component('akamSegmentedButton', akamSegmentedButton);
